import { CredentialShell } from './CredentialShell';
import { SignInForm } from './SignInForm';

/**
 * `/sign-in`, and the page the workspace shows in its own place when a read
 * answered 401 before anything was loaded (docs/DECISIONS.md ZD-118 §3).
 *
 * `reason` is the API's own sentence from that 401, shown so a person who was
 * sent here knows why; on the bare path there is none.
 */
export function SignInPage({
  reason = null,
  onSignedIn,
}: {
  reason?: string | null;
  onSignedIn: () => void | Promise<void>;
}): React.JSX.Element {
  return (
    <CredentialShell title="Sign in">
      {reason === null ? null : <p className="cred__reason">{reason}</p>}
      <SignInForm onSignedIn={onSignedIn} />
      <p className="cred__foot">
        There is no sign-up. Access is given by the person who administers Zevik for your
        organisation, who sends an invitation link.
      </p>
    </CredentialShell>
  );
}
